
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Link } from 'office-ui-fabric-react/lib/Link';

import Text from '../../common/client/components/Text';

const classNames = mergeStyleSets({
    dialogContent: {
    },
    selectedKatuzeContainer: {
        paddingTop: 8
    }
});

const KatuzeItem = ({katuzeItem, actionTitle, onClick}) => {
    const handleClick = () => {
        if (onClick) {
            onClick(katuzeItem)
        }
    }
    return (
        <Stack horizontal tokens={{childrenGap: 8}}>
            <Link
                onClick={handleClick}
                title={actionTitle}
            >
                {katuzeItem.nazev}
            </Link>
            <Text>({katuzeItem.kod})</Text>
        </Stack>
    );
}

const KatuzeItems = ({katuzeItems, actionTitle, onClick}) => {
    return katuzeItems.map(item => {
        return (
            <KatuzeItem
                key={item.kod}
                katuzeItem={item}
                actionTitle={actionTitle}
                onClick={onClick}
            />
        );
    });
}

const FilteredKatuzeItems = ({searchText, katuzeItems, onClick}) => {
    if (searchText.length > 1) {
        if (katuzeItems.length > 0) {
            let count = Math.min(katuzeItems.length, 10);
            let items = [];
            for (let i = 0; i < count; i++) {
                items.push(katuzeItems[i]);
            }
            const info = (count < katuzeItems.length)
                ? <div>  (zobrazuje se pouze prvních 10 z {katuzeItems.length} vyhledaných katastrálních území)</div>
                : null;
            return (
                <>
                    <KatuzeItems
                        katuzeItems={items}
                        actionTitle="Přidat katastrální území do vybraných"
                        onClick={onClick}
                    />
                    {info}
                </>
            )
        } else {
            return <div>Nebylo nalezeno žádné katastrální území</div>
        }
    } else {
        return <div>Zadejte alespoň 2 znaky z názvu nebo kódu katastrálního území</div>
    }
}

const SelectedKatuzeItems = ({katuzeItems, onClick}) => {
    return (
        <Stack className={classNames.selectedKatuzeContainer}>
            <Text bold>Vybraná katastrální území</Text>
            {(katuzeItems.length > 0)
                ? <KatuzeItems
                    katuzeItems={katuzeItems}
                    actionTitle="Odstranit katastrální území z vybraných"
                    onClick={onClick}
                />
                : <Text>Není vybrané žádné katastrální území</Text>
            }
        </Stack>
    );
}

const DialogContentAddKatuze = ({katuzeItems, onChange}) => {

    const [text, setText] = React.useState('');
    const [filteredKatuzeItems, setFilteredKatuzeItems] = React.useState([]);
    const [selectedKatuzeItems, setSelectedKatuzeItems] = React.useState([]);

    React.useEffect(() => {
        if (text.length > 1) {
            const searchText = text.toUpperCase();
            setFilteredKatuzeItems(
                katuzeItems.filter(item => {
                    return (
                        (item.nazev.toUpperCase().indexOf(searchText) !== -1) ||
                        (item.kod.toString().indexOf(searchText) === 0)
                    );
                })
            );
        } else {
            setFilteredKatuzeItems([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text]);

    React.useEffect(() => {
        if (onChange) {
            onChange(selectedKatuzeItems);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedKatuzeItems]);

    const handleChangeText = (event) => {
        setText(event.target.value);
    }

    const handleAddClick = (katuzeItem) => {
        setSelectedKatuzeItems(previous => {
            let exists = false;
            let newItems = [];
            previous.forEach(item => {
                if (item.kod === katuzeItem.kod) {
                    exists = true;
                }
                newItems.push(item);
            });
            if (!exists) {
                newItems.push(katuzeItem);
            }
            return newItems
        });
    }

    const handleRemoveClick = (katuzeItem) => {
        setSelectedKatuzeItems(previous => {
            return previous.filter(item => {
                return (item.kod !== katuzeItem.kod);
            });
        })
    }

    return (
        <div className={classNames.dialogContent}>
            <TextField
                label="Vyhledat katastrální území"
                value={text}
                onChange={handleChangeText}
            />
            <FilteredKatuzeItems
                katuzeItems={filteredKatuzeItems}
                searchText={text}
                onClick={handleAddClick}
            />
            <SelectedKatuzeItems
                katuzeItems={selectedKatuzeItems}
                onClick={handleRemoveClick}
            />
        </div>
    );
}

export default DialogContentAddKatuze;
